let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kBdWD")).then(() => parcelRequire('6Zxu7'));